var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Box",
    { staticClass: "table-wrapper" },
    [
      _c("h3", [
        _c("i", { staticClass: "far fa-lightbulb" }),
        _vm._v(" " + _vm._s(_vm.resource("AudienceManager_OverView_Concept")))
      ]),
      _vm._v(" "),
      _c("DataTable", {
        staticClass: "table table-striped",
        attrs: {
          data: _vm.conceptAudiences,
          columns: _vm.allColumns,
          options: { refresh: { enabled: true }, filter: { enabled: false } },
          loading: _vm.loading || _vm.loadingAudiences
        },
        on: {
          refresh: function($event) {
            return _vm.$emit("refresh")
          },
          delete: function($event) {
            _vm.idToDelete = $event.id
          },
          edit: function($event) {
            return _vm.navigateToBuilder($event.id)
          }
        }
      }),
      _vm._v(" "),
      _vm.idToDelete
        ? _c("Prompt", {
            attrs: {
              title: _vm.resource(
                "AudienceManager_OverView_Delete_Audience_Prompt_Title"
              ),
              body: _vm.promptBody,
              buttons: _vm.promptButtons,
              icon: "fas fa-trash-alt"
            },
            on: {
              yes: function($event) {
                return _vm.removeAudience(_vm.idToDelete)
              },
              no: function($event) {
                _vm.idToDelete = null
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }